let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6yy57"), load("ePOyH"), load("z7pZc")]).then(() => parcelRequire('jUVz4'));